import { Component, OnDestroy } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-end-users-sub-nav',
  templateUrl: './enterprise-end-users-sub-nav.component.html',
  standalone: false,
})
export class EnterpriseEndUsersSubNavComponent extends SubNavBaseComponent implements OnDestroy {
  Permission = SecurityPermissionName;

  public ngOnDestroy() {}
}
